import {Injectable} from 'ng-metadata/core';
import { FormBuilderEnums, FormBuilderService } from '../../../../infra/formBuilder/formBuilder.service';
import { DateUtils } from '../../../../nddUtils/dateUtils.service';

@Injectable()
export class GetItRequestService {
    
    constructor() {
    }    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/getItRequest.service.ts